import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PolteqTextField = _resolveComponent("PolteqTextField")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    id: "activateForm",
    ref: "activateForm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            "field-id": "usernameField",
            label: _ctx.i18n.t('fields.username'),
            rules: [_ctx.rules.email],
            type: "email",
            autocomplete: "username",
            icon: "mdi-email-outline"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            "field-id": "passwordField",
            label: _ctx.i18n.t('fields.password'),
            rules: [_ctx.rules.required],
            type: "password",
            autocomplete: "current-password",
            icon: "mdi-lock-outline"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.activationCode,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activationCode) = $event)),
            "field-id": "activationCodeField",
            label: _ctx.i18n.t('fields.activationCode'),
            rules: [_ctx.rules.required],
            type: "text",
            icon: "mdi-form-textbox-password"
          }, null, 8, ["modelValue", "label", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { style: {"text-align":"end"} }, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqButton, {
            "button-id": "loginButton",
            icon: "mdi-login-variant",
            "button-text": _ctx.i18n.t('buttons.signin'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activate(_ctx.username, _ctx.password, _ctx.activationCode)))
          }, null, 8, ["button-text"]),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _createVNode(_component_PolteqButton, {
            "button-id": "forgotPasswordButton",
            icon: "mdi-lock-question",
            "button-text": _ctx.i18n.t('texts.forgotpassword'),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.FORGOT_PASSWORD)))
          }, null, 8, ["button-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}